/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */

/** @module browser/modules/element-utils/add-styles */

/**
 * @description Adds passed styles to specified DOM element.
 * @param {HTMLElement} elem - Element.
 * @param {Object<string,(string|null)>} styles - Styles to be added.
 * @returns {void} Void.
 */
function addStyles(elem, styles) {
  for (var i in styles) {
    if (!Object.prototype.hasOwnProperty.call(styles, i)) {
      continue;
    }

    elem.style[i] = styles[i] === null ? '' : styles[i];
  }
}

export { addStyles };